import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Linkedin, Twitter, Instagram, Mail } from "lucide-react";

const cols = [
  {
    title: "Product",
    links: [
      { to: "/product", label: "Features" },
      { to: "/pricing", label: "Pricing" },
      { to: "/industries", label: "Industries" },
      { to: "/contact", label: "Book a Demo" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About" },
      { to: "/contact", label: "Contact" },
      { to: "/resources", label: "Blog" },
    ],
  },
  {
    title: "Resources",
    links: [
      { to: "/resources/marine-rental-guide", label: "Marine rental guide" },
      { to: "/resources/booking-vs-calendar", label: "Booking vs. calendar" },
      { to: "/resources/flexible-rental-software", label: "What flexible means" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms of Service" },
    ],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-ra-line bg-ra-paper" data-testid="site-footer">
      <div className="ra-container py-16">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_repeat(4,1fr)]">
          <div className="space-y-5">
            <Logo />
            <p className="text-sm text-ra-ink/70 max-w-xs">
              Booking and operations software flexible enough to rent anything. Built by operators, for operators.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn"
                 className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-ra-line bg-white text-ra-ink/70 transition-colors hover:text-ra-ocean hover:border-ra-ocean"
                 data-testid="footer-linkedin">
                <Linkedin size={16} />
              </a>
              <a href="https://x.com" target="_blank" rel="noreferrer" aria-label="X / Twitter"
                 className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-ra-line bg-white text-ra-ink/70 transition-colors hover:text-ra-ocean hover:border-ra-ocean"
                 data-testid="footer-twitter">
                <Twitter size={16} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram"
                 className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-ra-line bg-white text-ra-ink/70 transition-colors hover:text-ra-ocean hover:border-ra-ocean"
                 data-testid="footer-instagram">
                <Instagram size={16} />
              </a>
              <a href="mailto:inquiry@rentanything.ai" aria-label="Email"
                 className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-ra-line bg-white text-ra-ink/70 transition-colors hover:text-ra-ocean hover:border-ra-ocean"
                 data-testid="footer-email">
                <Mail size={16} />
              </a>
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-ra-ink/50 mb-4">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      className="text-sm text-ra-ink/80 hover:text-ra-ocean transition-colors"
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-ra-line pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-ra-ink/60" data-testid="footer-copyright">
            © {year} RentAnything.ai · All rights reserved.
          </p>
          <p className="text-xs text-ra-ink/60">
            Questions? <a className="ra-link" href="mailto:inquiry@rentanything.ai">inquiry@rentanything.ai</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
